import { Component } from '@angular/core';
import { BaseCellComponent } from '@adnova/jf-ng-components';

import { AnnouncementTableItem } from '../+definitions';

/**
 * Cell-Komponente für die ID-Spalte in der Announcement-Tabelle.
 *
 * Zeigt die eindeutige ID des Announcements an.
 * Diese Komponente hat keine eigene Logik und dient nur der Anzeige.
 *
 * @extends BaseCellComponent<AnnouncementTableItem>
 */
@Component({
  selector: 'app-id-cell',
  standalone: true,
  templateUrl: './id-cell.component.html',
})
export class IdCellComponent extends BaseCellComponent<AnnouncementTableItem> {}
